import { ValidationError } from "../../../models/ValidationError";
import { ValidationErrors } from "../../../models/ValidationErrors";
import { AssetForm } from "../../../store/forms";

export const validateClipGroupContent: (form: AssetForm) => ValidationErrors = (form) => {
    const errors: ValidationError[] = [];
    if (form.clipIds.length === 0) {
      errors.push({ fieldId: 'Clips', message: 'Atleast one clip is required to create Clip Group.' });
    }
    return new ValidationErrors(errors);
  };
  